import { memo, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { selectEarlyStagePriceTier } from "../../api/earlyStageMembershipApi";

interface EarlyStagePriceChoiceProps {
  /** Called after tier is saved; fee is £2 or £10 for immediate checkout display. */
  onComplete: (monthlyFeeGbp: number) => void;
}

function EarlyStagePriceChoiceInner({ onComplete }: EarlyStagePriceChoiceProps) {
  const [loading, setLoading] = useState(false);

  const choose = async (tier: "Standard2" | "Premium10") => {
    setLoading(true);
    try {
      await selectEarlyStagePriceTier(tier);
      toast.success("Payment option saved.");
      onComplete(tier === "Standard2" ? 2 : 10);
    } catch {
      toast.error("Could not save your payment choice. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className="mb-2 shadow-sm rounded-4 py-3">
      <Col md={12}>
        <p className="text-muted small mb-3">
          As an approved Early Stage member on the Young Professional rate, you can pay £2/month or
          £10/month. This choice cannot be changed after you complete payment.
        </p>
      </Col>
      <Col md={6} className="mb-3">
        <Card className="h-100">
          <Card.Body className="d-flex flex-column">
            <Card.Title>£2 / month</Card.Title>
            <Card.Text className="flex-grow-1 small text-muted">
              Young Professional rate at £2/month.
            </Card.Text>
            <Button
              variant="primary"
              disabled={loading}
              onClick={() => void choose("Standard2")}
            >
              Select £2/month
            </Button>
          </Card.Body>
        </Card>
      </Col>
      <Col md={6} className="mb-3">
        <Card className="h-100 border-primary">
          <Card.Body className="d-flex flex-column">
            <Card.Title>£10 / month</Card.Title>
            <Card.Text className="flex-grow-1 small text-muted">
              Full Early Stage membership at £10/month (same rate as members 23+).
            </Card.Text>
            <Button
              variant="outline-primary"
              disabled={loading}
              onClick={() => void choose("Premium10")}
            >
              Select £10/month
            </Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default memo(EarlyStagePriceChoiceInner);
